import { ModalReportGeneratorComponent } from './modal/modal-report-generator/modal-report-generator.component';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from '@views/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './angular-material/material/material.module';
import { JwtModule } from "@auth0/angular-jwt";
import { AuthGuard } from '@guards/auth.guard';
import { environment } from '@environment/environment';
import { RequestResetPasswordComponent } from '@views/request-reset-password/request-reset-password.component';
import { NavbarComponent } from '@shared/navbar/navbar.component';
import { HomeComponent } from '@views/home/home.component';
import { UnauthorizedInterceptor } from "@interceptors/unauthorized.interceptor";
import { ConfirmResetPasswordComponent } from '@views/confirm-reset-password/confirm-reset-password.component';
import { PageNotFoundComponent } from '@views/page-not-found/page-not-found.component';
import { AcceptTermsComponent } from '@views/accept-terms/accept-terms.component';
import { SafePipe } from '@pipes/safe.pipe';
import { ModalAggregatedReportComponent } from './modal/modal-aggregated-report/modal-aggregated-report.component';
import { AngularSvgIconModule } from "angular-svg-icon";
import { ModalDashboardComponent } from './modal/modal-dashboard/modal-dashboard.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ModalMapComponent } from './modal/modal-map/modal-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { ModalReportsComponent } from './modal/modal-reports/modal-reports.component';
import { ModalLoggerHealthComponent } from './modal/modal-logger-health/modal-logger-health.component';
import { ModalBillUploadComponent } from './modal/modal-bill-upload/modal-bill-upload.component';
import { ModalImportComponent } from './modal/modal-import/modal-import.component';
import {
    ChartsLineChartComponent
} from './modal/modal-dashboard/_components/charts-line-chart/charts-line-chart.component';
import { ResourceSeriesChartComponent } from './modal/modal-reports/_components/resource-series-chart/resource-series-chart.component';
import { ResourceSeriesPieComponent } from './modal/modal-reports/_components/resource-series-pie/resource-series-pie.component';
import { WhatIfPanelComponent } from './modal/modal-reports/_components/resource-series-chart/what-if-panel.component';
import { HiddenTestNotificationComponent } from '@views/hidden-test-notification/hidden-test-notification.component';
import { LiveDisplayComponent } from '@views/live-display/live-display.component';
import { LiveDisplayKioskSetupComponent } from '@views/live-display/kiosk-setup/live-display-kiosk-setup.component';
import { DragDropModule } from "@angular/cdk/drag-drop";

function tokenGetter() {
    return localStorage.getItem("jwt");
}

@NgModule({
    declarations: [
        ModalReportGeneratorComponent,
        // components
        AppComponent,
        LoginComponent,
        RequestResetPasswordComponent,
        NavbarComponent,
        HomeComponent,
        ConfirmResetPasswordComponent,
        PageNotFoundComponent,
        AcceptTermsComponent,
        ModalAggregatedReportComponent,
        ModalDashboardComponent,
        ModalMapComponent,
        ModalReportsComponent,
        ModalLoggerHealthComponent,
        ModalBillUploadComponent,
        ModalImportComponent,
        ChartsLineChartComponent,
        ResourceSeriesChartComponent,
        ResourceSeriesPieComponent,
        WhatIfPanelComponent,
        HiddenTestNotificationComponent,
        LiveDisplayComponent,
        LiveDisplayKioskSetupComponent,

        // pipes
        SafePipe,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        AngularSvgIconModule.forRoot(),
        GoogleMapsModule,
        NgxChartsModule,
        JwtModule.forRoot({
            config: {
                tokenGetter,
                allowedDomains: [environment.allowedDomain],
            }
        }),
        DragDropModule
    ],
    providers: [AuthGuard, { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true }],
    bootstrap: [AppComponent]
})
export class AppModule {
}
